import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionService {

  constructor(private http: HttpClient) {}

  save(body): Observable<any> {
    return this.http.post<any>(`${environment.apis.lineupUrl}subscription/v1`, body);
  }

  getAll() : Observable<any[]> {
    return this.http.get<any[]>(`${environment.apis.lineupUrl}subscription/v1`);
  }

  getDetails(voyageId, terminalId) : Observable<any> {
    return this.http.get<any>(`${environment.apis.lineupUrl}subscription/v1/details?voyageId=${voyageId}&terminalId=${terminalId}`);
  }
}